import { useEffect, useState } from "react";
import EntityEditor from "../components/EntityEditor";
import { adminApi } from "../api";

const FIELDS = [
  { key: "name", label: "Nome logo (alt text)", required: true },
  { key: "image", label: "Immagine / logo (PNG o SVG trasparente consigliato)", type: "image" },
  { key: "caption", label: "Etichetta (es. '★★★★ · Stazione Centrale')", placeholder: "opzionale" },
  { key: "url", label: "Link al click (opzionale)", type: "url", placeholder: "https://…" },
  { key: "order", label: "Ordine di visualizzazione", type: "number" },
  { key: "published", label: "Visibile nella slide", type: "checkbox" },
];

const INITIAL = {
  name: "",
  image: "",
  caption: "",
  url: "",
  order: 999,
  published: true,
};

export default function AdminMarquee() {
  const [items, setItems] = useState([]);

  const load = () =>
    adminApi.get("/admin/marquee-logos").then((r) => setItems(r.data));

  useEffect(() => {
    load();
  }, []);

  return (
    <EntityEditor
      title="Loghi Marquee"
      subtitle="La striscia scorrevole in alto alla home. Se non aggiungi nulla, vengono mostrati i loghi degli hotel. Carica qui loghi, partner, certificazioni o rebrand."
      endpoint="/admin/marquee-logos"
      fields={FIELDS}
      items={items}
      initial={INITIAL}
      onReload={load}
      renderRow={(item) => (
        <div>
          <div className="font-display text-lg">{item.name}</div>
          <div className="mt-1 text-xs text-white/50 font-mono uppercase tracking-[0.15em]">
            ordine {item.order}
            {item.caption && <span className="ml-3">· {item.caption}</span>}
            {item.published === false && (
              <span className="ml-3 text-red-400">NASCOSTO</span>
            )}
          </div>
        </div>
      )}
    />
  );
}
